import React from 'react';
import { useStyletron } from 'baseui';
import { ERROR_SEVERITY } from '../constants';

type ErrorKeys = keyof typeof ERROR_SEVERITY;

interface IErrorMessage {
	message: string;
	severity: typeof ERROR_SEVERITY[ErrorKeys];
}

const ErrorMessage: React.FC<IErrorMessage> = ({ message, severity }) => {
	const [css] = useStyletron();

	const errorColor = severity === ERROR_SEVERITY.ERROR ? '#bf1650' : '#FFA500';
	return <span className={css({ color: errorColor })}>{message}</span>;
};

export default ErrorMessage;
